angular.module('picmonicng').factory('PathwaySectionsResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/pathway_sections');
  },
]);
